module.exports = __webpack_public_path__ + "img/1446321137.07bb3dbd.jpg";